import { ILocation } from "../AlacrityInterfaces";

export interface ILocationExtended extends ILocation {
    country?: string;
    stateCode?: string;
    stateName?: string;
    countyCode?: string;
    countyName?: string;
    cityCode?: string;
    cityName?: string;
    townshipCode?: string;
    townshipName?: string;
    latitude?: number;
    longitude?: number;
    zipcode?: string;
    streetNumber?: string;
    streetName?: string;
    intersectStreetName?: string;
    distanceFromIntersection?: number;
    bearing?: number;
    zoomLevel?: number;
    notOnRoadway?: boolean;
    unableToMap?: boolean;
    snappedToRoadway?: boolean;
    atIntersection?: boolean;
    interstateDirection?: string;
    milepost?: number;
    roadwayNumber?: string;
    roadwayInterchange?: string;
    roadwayRamp?: string;
    milepostRoute?: string;
    distance?: string;
    bearingDirection?: string;
    isPrivateProperty?: boolean;
    referencePostInfo?: IReferencePostInfo[];
}

export default class LocationExtended implements ILocationExtended {
    country: string;
    stateCode: string;
    countyCode: string;
    countyName: string;
    cityCode: string;
    cityName: string;
    townshipCode: string;
    townshipName: string;
    latitude: number;
    longitude: number;
    zipcode: string;
    streetNumber: string;
    streetName: string;
    intersectStreetName: string;
    distanceFromIntersection: number;
    bearing: number;
    zoomLevel: number;
    notOnRoadway: boolean;
    unableToMap: boolean;
    snappedToRoadway: boolean;
    stateName: string;
    atIntersection: boolean;
    interstateDirection: string;
    milepost: number;
    roadwayNumber: string;
    roadwayInterchange: string;
    roadwayRamp: string;
    milepostRoute: string;
    distance: string;
    bearingDirection: string;
    isPrivateProperty: boolean;
    referencePostInfo: IReferencePostInfo[];
    constructor(country?: string, stateCode?: string, countyCode?: string, countyName?: string, cityCode?: string, cityName?: string, townshipCode?: string, townshipName?: string, latitude?: number, longitude?: number, zipcode?: string, streetNumber?: string, streetName?: string, intersectStreetName?: string, distanceFromIntersection?: number, bearing?: number, zoomLevel?: number, notOnRoadway?: boolean, unableToMap?: boolean, snappedToRoadway?: boolean, stateName?: string, atIntersection?: boolean, interstateDirection?: string, milepost?: number, roadwayNumber?: string, roadwayInterchange?: string, roadwayRamp?: string, milepostRoute?: string, distance?: string, bearingDirection?: string, isPrivateProperty?: boolean) {};
    static equals: (location1: ILocationExtended, location2: ILocationExtended) => boolean;
}

export interface IReferencePostInfo {
    beginningReferencePost: number;
    endingReferencePost: number;
    routeID:string;
}